// extracted by mini-css-extract-plugin
module.exports = {"subscribed":"BrandSubscriptionButton_subscribed__M3Olb","unsubscribed":"BrandSubscriptionButton_unsubscribed__Sf6dn"};